export const stage_admin_ids = [
    'dWYA1z3bw7XMtv2sOe9N0G9Cbm62', // Will
];

export const prod_admin_ids = [
    'Jd7fUyy7rGfMHCUNxAFSOGunCus2', // Ryan
    'Lf5R1OHQ0lPsSLipqKtcOHF5vpM2', // Jessie
    'uTeaWjxEdLNK5cGK9B6FUQtZYdu2', // Will
];
